import { render, staticRenderFns } from "./QuestionAnswerPageSwitchEdit.vue?vue&type=template&id=e9a7cdde&scoped=true"
import script from "./QuestionAnswerPageSwitchEdit.vue?vue&type=script&lang=js"
export * from "./QuestionAnswerPageSwitchEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a7cdde",
  null
  
)

export default component.exports